<div class="container-fluid contact-bar">
    <div class="row">
        <div class="col-lg-6 pt-120">
            <div class="row">
                <div class="col-12 text-center">
                    <h1>Information</h1>
                    <br>
                    <h3>Eazy Breezy Heating & Cooling</h3>
                    <br>
                    <p>Phone: 587-596-3040
                        <br>
                        Email: <span class="text-bold">info@eazybreezyhc.com</span>
                    </p>
                    <br>
                    <h3>Servicing Area</h3>
                    <br>
                    <p>Edmonton, AB
                        <br>
                        and surrounding area
                    </p>
                    <br>
                    <h3>Hours of Operation</h3>
                    <br>
                    <p>Mon-Fri &nbsp; 8:00 AM-5:00 PM*
                    </p>
                    <p class="text-smaller">*After Hours Available</p>
                </div>
            </div>

            <div class="row pt-5">
                <div class="col-12 d-flex justify-content-center">
                    <div class="yellow-page-break">&nbsp;</div>
                </div>
            </div>

            <div class="row pt-5 contact-quip-media">
                <div class="col-12 d-flex justify-content-center">
                    <h3 class="text-blue text-center">Tired of talking to an automated phone system?<br>Call Eazy Breezy to speak to a live person!</h3>
                </div>
            </div>

            <div class="row pt-5 contact-quip-media">
                <div class="col-12 d-flex justify-content-center">
                    <div class="yellow-page-break">&nbsp;</div>
                </div>
            </div>

            <!--FORM-->
            <div class="row pt-5">
                <div class="col-12 text-center contact-form">
                    <h1>Get In Touch</h1>
                    <div class="row mt-5">
                        <div class="col-md-6">
                            <div class="input-group w-form">
                                <input type="text" class="form-control" placeholder="Name*" [(ngModel)]="contactName">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group w-form float-right">
                                <input type="text" class="form-control" placeholder="Company" [(ngModel)]="contactCompany">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-md-6">
                            <div class="input-group w-form">
                                <input type="text" class="form-control" placeholder="Phone*" [(ngModel)]="contactPhone">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group w-form float-right">
                                <input type="text" class="form-control" placeholder="Email*" [(ngModel)]="contactEmail">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-md-6">
                            <div class="input-group w-form">
                                <input type="text" class="form-control" placeholder="Address*" [(ngModel)]="contactAddress">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <select class="form-select form-control w-form float-right" [(ngModel)]="contactReferral">
                                <option selected>Where did you hear about us?</option>
                                <option>Internet Search</option>
                                <option>Referral</option>
                                <option>Physical Advertising</option>
                                <option>Social Media</option>
                                <option>Other</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-md-6">
                            <div class="input-group w-form">
                                <input type="text" class="form-control" placeholder="Project Name" [(ngModel)]="contactProject">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group w-form float-right">
                                <input type="text" class="form-control" placeholder="Project Due Date" [(ngModel)]="contactDue">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-md-12">
                            <textarea rows="3" class="form-control" placeholder="Additional Details" [(ngModel)]="contactDetails"></textarea>
                        </div>
                    </div>
                    <div class="row mt-5 mb-5">
                        <div class="col-12 d-flex justify-content-center verticle-center-text" *ngIf="mailSent === false">
                            <div class="action-button-reverse d-flex justify-content-center" (click)="submitMessage()"><span class="mt08">SUBMIT</span></div>
                        </div>
                        <div class="col-12 d-flex justify-content-center">
                            <p>{{ submitMsg }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 contact-img split-img">
            <div class="contact-quip">
                <h3 class="text-blue">Tired of talking to an automated phone system?
                    <br>
                    Call Eazy Breezy to speak to a live person!
                </h3>
            </div>
        </div>
    </div>
</div>